import { LocationNumbersService } from '../../../services'

const editNumberPool = async function ({ dispatch, state }, config) {
  const { locationId, numberPoolId, payload } = config
  try {
    const data = await LocationNumbersService.updateNumberPool(locationId, numberPoolId, payload)
    await dispatch('fetchLocationTwilio', locationId)
    await dispatch('fetchNumberPool', {
      numberPools: state.numberPoolIDs,
      locationId: locationId,
      getPaginatedDataOnly: false,
      payload: {
        limit: state.table?.limit,
        page: state.table?.currentPage,
        query: state.table?.searchText ?? '',
      },
    })

    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default editNumberPool
